export default __webpack_public_path__ + "static/media/UnmappedFile.d079dc1f.png";